import { schema } from "normalizr";
import { PageLayoutComponent as Record } from "records/page";

export const PageLayoutComponentSchema = new schema.Entity(
    "pageLayoutComponents",
    {},
    {
        idAttribute: (component) => {
            return component.display_properties?.componentUuid || component.ref_id;
        },
    },
);

(PageLayoutComponentSchema as any).record = Record;
